function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCnt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 4956",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.054,
    height: 21.478,
    viewBox: "0 0 20.054 21.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3137",
    d: "m641.622 376.084 2.483-1.536.485-.3h8.062a5.019 5.019 0 0 0 5.012-5.013v-4.01a5.02 5.02 0 0 0-5.012-5.014h-6.017a5.02 5.02 0 0 0-5.013 5.014v10.86m-2.005 3.6v-14.461a7.019 7.019 0 0 1 7.019-7.02h6.017a7.019 7.019 0 0 1 7.018 7.02v4.01a7.018 7.018 0 0 1-7.018 7.019h-7.492z",
    transform: "translate(-639.617 -358.204)",
    style: {
      fill: "#5b646b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3147",
    d: "M653.207 366.21h-5.589a1 1 0 1 1 0-2.005h5.589a1 1 0 0 1 0 2.005z",
    transform: "translate(-640.386 -356.222)",
    style: {
      fill: "#5b646b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3148",
    d: "M6.591 2.005H1A1 1 0 1 1 1 0h5.591a1 1 0 0 1 0 2.005z",
    transform: "rotate(90 2.92 8.11)",
    style: {
      fill: "#5b646b"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCnt);
export default __webpack_public_path__ + "static/media/add-cnt.b40c6fff.svg";
export { ForwardRef as ReactComponent };